var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div-box',{attrs:{"bg":"#fff"}},[_c('nav-bar',{attrs:{"title":_vm.$t('制度说明'),"leftArrow":true}}),_c('div-padding',{attrs:{"padding":"4vw"}},[_c('div-html',{attrs:{"html":_vm.info}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }